import car from '../../assets/car (2).png';

function BodySection1() {
  return (
    <section className="mc-value-section">
      <div className="container mc-container">
        <div className="mc-value-card">
          <div className="mc-value-content">
            <span className="mc-section-kicker">POURQUOI MOOVICAR ?</span>

            <h2>
              La location de voiture,
              <span>réinventée autour de vous.</span>
            </h2>

            <p className="mc-value-intro">
              Moovicar connecte conducteurs et propriétaires pour créer une expérience de location
              plus flexible, plus simple et plus proche de vos besoins.
            </p>

            <div className="mc-benefits">
              <div className="mc-benefit">
                <div className="mc-benefit-icon">
                  <i className="bi bi-lightning-charge-fill" />
                </div>

                <div>
                  <h3>Simple & rapide</h3>

                  <p>Trouvez un véhicule disponible autour de vous en quelques clics.</p>
                </div>
              </div>

              <div className="mc-benefit">
                <div className="mc-benefit-icon">
                  <i className="bi bi-shield-check" />
                </div>

                <div>
                  <h3>Une expérience sécurisée</h3>

                  <p>Votre location est assurée par AXA pour voyager plus sereinement.</p>
                </div>
              </div>

              <div className="mc-benefit">
                <div className="mc-benefit-icon">
                  <i className="bi bi-headset" />
                </div>

                <div>
                  <h3>Une expérience humaine</h3>

                  <p>Une plateforme pensée pour connecter facilement les bonnes personnes.</p>
                </div>
              </div>
            </div>

            <a className="mc-outline-button" href="#comment-ca-marche">
              Découvrir l'expérience
              <i className="bi bi-arrow-up-right" />
            </a>
          </div>

          <div className="mc-value-media">
            <div className="mc-value-background-grid" />

            <div className="mc-value-image-wrapper">
              <img src={car} alt="Voiture disponible à la location" />
            </div>

            <div className="mc-value-floating">
              <div className="mc-value-floating-icon">
                <i className="bi bi-stars" />
              </div>

              <div>
                <small>MOOVICAR AI</small>
                <strong>Une mobilité plus intelligente</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BodySection1;
